module.exports = __webpack_public_path__ + "media/packs/fonts/IsidoraSans-BoldItalic-4526608b945c10da7ac2130c8ae92d93.woff2";